import { useCallback } from 'react';
import i18n from 'i18next';

export const useSubtypeMapping = () => {
    const handleMapping = useCallback(
        (subtype?: string) =>
            subtype
                ? (i18n.t(`prosjekt.table.subTypes.${subtype}`) ?? subtype)
                : undefined,
        [],
    );

    return { handleMapping };
};
